import React from 'react'
import { Button } from 'react-bootstrap'
import { Modal } from 'react-bootstrap'
let path_image = process.env.REACT_APP_ASSETS_PATH_INFORMED_DESIGN;

const CommonModals = ({bodyText, Buttons }) => {
  return (
    <> 
      <h4>{bodyText || ""}</h4>
      <div className="modal-buttons">
        {Buttons?.map((button, index) => (
          <Button key={index} className={button.className} onClick={button.click}>
            {button.text}
            {button.icon && <img src={path_image + button.icon} alt="" />}
          </Button>
        ))}
      </div>
      </>
  );
};


export default CommonModals